"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "InfiniteScrollTable", {
    enumerable: true,
    get: function() {
        return InfiniteScrollTable;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _ProgressCircle = require("../ProgressCircle/ProgressCircle");
const _reactinfinitescrollcomponent = /*#__PURE__*/ _interop_require_default(require("react-infinite-scroll-component"));
const _StickyHeaderTable = require("./StickyHeaderTable");
const _localisationeq1 = require("@equiem/localisation-eq1");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const Loader = (param)=>{
    let { loading, hasMoreData, colSpan, scrollDownToLoad } = param;
    const { t } = (0, _localisationeq1.useTranslation)();
    return loading || hasMoreData ? /*#__PURE__*/ _react.default.createElement("tr", null, /*#__PURE__*/ _react.default.createElement("td", {
        colSpan: colSpan
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: "mt-6 mb-6 d-flex justify-content-center align-items-center"
    }, loading ? /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement(_ProgressCircle.ProgressCircle, {
        size: "md"
    }), /*#__PURE__*/ _react.default.createElement("span", {
        className: "ml-4"
    }, "".concat(t("common.loading"), "..."))) : // `react-infinite-scroll-component` only checks if it needs to request
    // more data on scroll, not on initial data load, so if the first page of
    // data doesn't fill the screen it won't immediately load more data.
    //
    // In that scenario, we should show them some indication that there's
    // more data available and how to get it.
    //
    // This should never be visible to the user unless they've got a
    // *really* tall screen.
    scrollDownToLoad !== null && scrollDownToLoad !== void 0 ? scrollDownToLoad : t("common.scrollDownToLoad")))) : null;
};
const InfiniteScrollTable = (param)=>{
    let { loading, hasMoreData, scrollDownToLoad, className, rowHeaders, overlayHeader, sort, rowCount, children, fetchMore } = param;
    return /*#__PURE__*/ _react.default.createElement(_reactinfinitescrollcomponent.default, {
        next: fetchMore,
        dataLength: rowCount,
        hasMore: hasMoreData,
        loader: null,
        style: {
            overflow: undefined
        },
        className: className
    }, /*#__PURE__*/ _react.default.createElement(_StickyHeaderTable.StickyHeaderTable, {
        rowHeaders: rowHeaders,
        overlayHeader: overlayHeader,
        loading: false,
        sort: sort,
        responsive: true
    }, children, /*#__PURE__*/ _react.default.createElement(Loader, {
        loading: loading,
        hasMoreData: hasMoreData,
        colSpan: rowHeaders.length,
        scrollDownToLoad: scrollDownToLoad
    })));
};

//# sourceMappingURL=InfiniteScrollTable.js.map